import { createReducer, on } from '@ngrx/store';

import { PagedBase } from '../general/models/general';
import {
  IAssociatedEntities,
  IVulnerability,
  IVulnerabilityAsset,
  IVulnerabilityOccurence,
  IVulnerabilityOverview,
} from './models/Vulnerability';
import * as actions from './vulnerabilities.actions';

export const VULNERABILITIES_FEATURE_KEY = 'vulnerabilities';

export interface VulnerabilitiesState extends PagedBase {
  vulnerabilities: IVulnerability[];
  vulnerabilityById: IVulnerabilityOverview;
  vulnerability: IVulnerability;
  associatedEntities: IAssociatedEntities;
  isLoading: boolean;
  isResoveUnResolveLoading: boolean;
  vulnerabilitiesAssets: IVulnerabilityAsset[];
  occurences: IVulnerabilityOccurence[];
}

export const initialState: VulnerabilitiesState = {
  vulnerabilities: [],
  vulnerabilityById: null,
  vulnerability: null,
  associatedEntities: null,
  isLoading: false,
  isResoveUnResolveLoading: false,
  hasMore: false,
  pageNumber: 1,
  pageSize: 0,
  totalCount: undefined,
  totalPages: 0,
  vulnerabilitiesAssets: [],
  occurences: [],
};

export const vulnerabilitiesReducer = createReducer(
  initialState,
  on(actions.getVulnerabilities, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getVulnerabilitiesSuccess,
    (state, { pagedVulnerabilities: { items, ...rest } }) => ({
      ...state,
      ...rest,
      vulnerabilities:
        rest.pageNumber === 1
          ? [...items]
          : [...state.vulnerabilities, ...items],
      isLoading: false,
    }),
  ),
  on(actions.getVulnerabilityById, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getVulnerabilityByIdSuccess, (state, { vulnerabilityById }) => ({
    ...state,
    vulnerabilityById,
    isLoading: false,
  })),
  on(actions.vulnerabilityAssociatedEntities, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.vulnerabilityAssociatedEntitiesSuccess,
    (state, { associatedEntities }) => ({
      ...state,
      associatedEntities,
      isLoading: false,
    }),
  ),
  on(actions.resolveVulnerability, (state) => ({
    ...state,
    isResoveUnResolveLoading: true,
  })),
  on(actions.resolveVulnerabilitySuccess, (state, { vulnerabilityId }) => {
    const updatedVulnerabilities = state.vulnerabilities.map(
      (oldVulnerability) => {
        if (oldVulnerability.id === vulnerabilityId) {
          return {
            ...oldVulnerability,
            resolvedStatus: true,
            resolvedAt: new Date().toString(),
          };
        }
        return oldVulnerability;
      },
    );
    return {
      ...state,
      vulnerabilities: updatedVulnerabilities,
      isResoveUnResolveLoading: false,
    };
  }),
  on(actions.unresolveVulnerability, (state) => ({
    ...state,
    isResoveUnResolveLoading: true,
  })),
  on(actions.unresolveVulnerabilitySuccess, (state, { vulnerabilityId }) => {
    const updatedVulnerabilities = state.vulnerabilities.map(
      (oldVulnerability) => {
        if (oldVulnerability.id === vulnerabilityId) {
          return {
            ...oldVulnerability,
            resolvedStatus: false,
            resolvedAt: null as string | null,
          };
        }
        return oldVulnerability;
      },
    );
    return {
      ...state,
      vulnerabilities: updatedVulnerabilities,
      isResoveUnResolveLoading: false,
    };
  }),

  on(
    actions.getVulnerabilitiesAssetsSuccess,
    (state, { vulnerabilitiesAssets }) => ({
      ...state,
      vulnerabilitiesAssets: [...vulnerabilitiesAssets],
    }),
  ),
  on(
    actions.getVulnerabilityOccurencesSuccess,
    (state, { pagedVulnerabilityOccurences: { items, ...rest } }) => ({
      ...state,
      ...rest,
      occurences:
        rest.pageNumber === 1 ? [...items] : [...state.occurences, ...items],
      isLoading: false,
    }),
  ),
);
